import { useQuery } from '@tanstack/react-query';

import httpClient from './httpClient';
import { useSelectedSubaccountId } from './selectedSubaccount';

const getQueryFunction = ({ queryKey: [endpoint, id] }) => new Promise((resolve, reject) => {

  endpoint = id ? `${endpoint}/${id}/` : `${endpoint}/`;
  httpClient.get(endpoint)
    .then(({ data }) => {
      resolve(data);
    })
    .catch((e) => {
      reject(e);
    });
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Get = (endpoint, params, config) => {
  // subaccountId is part of the cache key so different accounts never share a
  // cache entry (the request itself is scoped by the httpClient interceptor).
  const subaccountId = useSelectedSubaccountId();

  return useQuery({
    queryKey: [endpoint, params, subaccountId],
    queryFn: getQueryFunction,
    // Defaults before ...config so callers can override the cadence/retries.
    refetchInterval: 30 * 1000,
    retry: 1,
    ...config,
  });
};

export default Get;
